export default "/73a77447bc763a123c8b623ab714a12f.jpg";